// extracted by mini-css-extract-plugin
export default {"interstitial_container":"K5","interstitial_img":"L5","interstitial_text_container":"M5","interstitial_text":"N5","interstitial_container_noPic":"O5"};
    if(module.hot) {
      // 1730991512693
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  